// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpandingBlock_root__1kT0X","rightArrow":"ExpandingBlock_rightArrow__EPqyH","rightArrow90":"ExpandingBlock_rightArrow90__KpF9M"};